import React from "../index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { useSiteSettings } from "../sanity/useSiteSettings";

export const Footer = () => {
    const {data} = useSiteSettings();
    const footer = data?.footer || {};
    const email = footer.email || "info@biodanzaschule-freiburg.de";
    const copyrightText = footer.copyrightText || "Copyright © 2024 Biodanzaschule Freiburg";
    const impressumLabel = footer.impressumLabel || "Impressum";
    const datenschutzLabel = footer.datenschutzLabel || "Datenschutzerklärung";
    const createdByText = footer.createdByText || "Created with";
    const createdByName = footer.createdByName || "Joanna Cwalina";
    const createdByUrl = footer.createdByUrl || "https://joannacwalina.dev";

    // const location = useLocation(); // Getting the current location
    //
    // // Conditionally rendering the footer-pic based on the path
    // const renderFooterPic = location.pathname !== "/kontakt";
    //


    return (
        <div>
            {/*{renderFooterPic && ( // Rendering footer-pic only if renderFooterPic is true*/}
            <div className=" center">
                <div className="footer-pic">
                </div>
            </div>

            {/*)}*/}

            <div className="footer center">

                {/*<div className=" center">*/}
                {/*    <img src={Logo} alt="Logo" style={{height: "100px"}}/>*/}
                {/*</div>*/}

                <div className="pt-3">
                    <a
                        href={`mailto:${email}`}> {email}</a>
                </div>


                <div className="">{copyrightText}</div>

                <div className="d-flex flex-row ">
                    <a href="/impressum"
                        className="footer-link-spacing">{impressumLabel}</a>
                    <a href="/datenschutzerklaerung"
                        className="">{datenschutzLabel}</a>
                </div>

                <div className="text-center">


                    {createdByText} <FontAwesomeIcon icon={faHeart} className="fontawesome-heart" /> by
                    <a className="created-by-link" href={createdByUrl} rel="noreferrer" target="_blank" >{createdByName}</a>
                </div>

            </div>
        </div>
    )


}
